
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/concepts/[slug]",
      function () {
        return require("private-next-pages/concepts/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/concepts/[slug]"])
      });
    }
  